import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { CommonPagination } from '../../../home/graph/manage-graphs/graph.component';
import { jwtDecode } from 'jwt-decode';
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private router: Router, ) {}

  startLoading() {
    sessionStorage.setItem('loader', 'Yes');
  }

  stopLoading() {
    sessionStorage.removeItem('loader');
  }

  getLoggedInToken() {
    var loggedInUserData = JSON.parse(
      localStorage.getItem('isLoggedIn') || '{}'
    );
    return loggedInUserData?.token??"";
  }
  getPermissionList() {
    const permissionsList = JSON.parse(
      localStorage.getItem('permissions') || '{}'
    );
    return permissionsList??[];
  }

  getUserDetails() {
    let userData;
    if (localStorage.getItem('isLoggedIn')) {
      const storedData = JSON.parse(localStorage.getItem('isLoggedIn') || '{}');
      userData = storedData.data?.user || {};
    }
    return userData || {};
  }

  logoutWithAllDataClear() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigateByUrl('auth/login');
  }

  removeDuplicateValuesFromArray(arrayData: any[], key: any) {
    return [...new Map(arrayData.map((x) => [key(x), x])).values()];
  }
  checkPermissions(permissionName: string) {
    if (
      this.getPermissionList()?.length &&
      this.getPermissionList()?.includes(permissionName)
    )
      return true;
    else return false;
  }
  onlyAllowedNumberValue(event: any) {
    var regex = new RegExp('^[0-9]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) return true;

    return;
  }

  onlyAllowedDecimalValue(event: any) {
    var regex = new RegExp('^[0-9.]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );

    if (!regex.test(key)) {
      return true;
    }
    return;
  }
  commonOnPasteOnlyAllowedNumber(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') ?? '';
    const regex = /^[0-9]*$/;
    if (!regex.test(pastedText)) return true;
    return;
  }
  restrictSpaceSpecialNotAllowed(event: any) {
    var regex = new RegExp('^[a-zA-Z0-9- ]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) {
      return true;
    }
    return;
  }
  sortDataAccordingParams(arrayList: any[], keyName: string, isAsc: boolean) {
    arrayList.sort((a: any, b: any) => {
      return (a[keyName] < b[keyName] ? -1 : 1) * (isAsc ? 1 : -1);
    });
    return arrayList;
  }
  // commonUpdatePaginationMethod(commonPaginationObj: CommonPagination) {
  //   let modifiedCommonPaginationObj: CommonPagination = {
  //     currentPage: commonPaginationObj.currentPage ?? 1,
  //     itemsPerPage: commonPaginationObj.itemsPerPage ?? 10,
  //     totalItems: commonPaginationObj.totalItems ?? 0,
  //     totalPages: commonPaginationObj.totalPages ?? 0,
  //     pages: commonPaginationObj.pages,
  //   };
  //   if (commonPaginationObj.totalPages <= 3)
  //     modifiedCommonPaginationObj.pages = Array.from(
  //       { length: commonPaginationObj.totalPages },
  //       (_, i) => i + 1
  //     );
  //   else if (commonPaginationObj.currentPage <= 2)
  //     modifiedCommonPaginationObj.pages = [1, 2, 3];
  //   else if (
  //     commonPaginationObj.currentPage >=
  //     commonPaginationObj.totalPages - 1
  //   )
  //     modifiedCommonPaginationObj.pages = [
  //       commonPaginationObj.totalPages - 2,
  //       commonPaginationObj.totalPages - 1,
  //       commonPaginationObj.totalPages,
  //     ];
  //   else
  //     modifiedCommonPaginationObj.pages = [
  //       commonPaginationObj.currentPage - 1,
  //       commonPaginationObj.currentPage,
  //       commonPaginationObj.currentPage + 1,
  //     ];

  //   return modifiedCommonPaginationObj;
  // }
  getDecodedUserDetails() {
    try {
      const token = this.getLoggedInToken();
      const decodedToken: any = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      return null; // Return null if token is invalid
    }
  }
}
